import { render, staticRenderFns } from "./DreceiptCreate.vue?vue&type=template&id=5d5f5533&scoped=true"
import script from "./DreceiptCreate.vue?vue&type=script&lang=js"
export * from "./DreceiptCreate.vue?vue&type=script&lang=js"
import style0 from "./DreceiptCreate.vue?vue&type=style&index=0&id=5d5f5533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f5533",
  null
  
)

export default component.exports